import { createAction, props } from '@ngrx/store';
import { ILegalEntitiesCreateBusinessRequest } from '../models/create-business.model';

export const loadCreateBusiness = createAction(
  '[LegalEntities] Load Legal Entities Create a Business',
  props<{ request: ILegalEntitiesCreateBusinessRequest }>()
);

export const loadCreateBusinessSuccess = createAction(
  '[LegalEntities] Load Legal Entities Create a Business Success',
  props<{ response: string }>()
);

export const loadCreateBusinessFailure = createAction(
  '[LegalEntities] Load Legal Entities Create a Business Failure',
  props<{ error: Error | any }>()
);
